import {
    getKpiGetProgress,
    getKpiGetSalaryToPay,
    getSchedulerAllSchedule,
    thunkCall,
} from "tm-shared/api";

export const getSchedulerAllScheduleSvThunk = thunkCall(
    "getSchedulerAllScheduleSv",
    getSchedulerAllSchedule,
);

export const getKpiGetProgressSvThunk = thunkCall(
    "getKpiGetProgressSv",
    getKpiGetProgress,
);

export const getKpiGetSalaryToPaySvThunk = thunkCall(
    "getKpiGetSalaryToPaySv",
    getKpiGetSalaryToPay,
);
